module.exports = __webpack_public_path__ + "static/media/topic-img3.04bed026.png";